import FretteSection from './FretteSection';

export default FretteSection;
